import Text from '../Typography/Text';
import { media } from '../../styles/media';
import styled from 'styled-components';

export const WrapperAudioPlayer = styled.div`
  margin: 0 58px ${props => props.theme.layout.gutter * 2}px;
`;

export const TitleContent = styled.div`
  margin-bottom: 10px;
`;

export const YoutubePlayer = styled.iframe`
  width: 100%;
  height: 229px;
`;

export const YoutubePlayerSingle = styled(YoutubePlayer)`
  height: 229px;

  ${media.tablet`
  height: 400px;

`} ${media.desktop`
    height: 500px;

  `};
`;

export const WrapperSlider = styled.div``;

export const SlideWrapper = styled.div``;

export const SlideTitleWrapper = styled.div`
  margin-top: 20px;
`;

export const WrapperButton = styled.div`
  margin: 40px auto 0;
`;
